import { FC } from 'react';
import { Icon } from '@aidkitorg/component-library';
import { InfoFieldProps } from '../shared/types';

/**
 * Reusable component for displaying a label/value pair with optional verified icon
 */
export const InfoField: FC<InfoFieldProps> = ({ label, value, verified }) => {
  return (
    <div className="min-w-0">
      <div className="text-sm font-medium text-gray-900 break-words overflow-wrap-anywhere">{label}</div>
      <div className="text-base text-gray-600 mt-1 flex items-center gap-2 min-w-0">
        <span className="text-sm break-words overflow-wrap-anywhere min-w-0">{value}</span>
        {verified && (
          <Icon role="decorative" type="solid" name="CheckCircleIcon" className="w-5 h-5 text-green-600 flex-shrink-0" />
        )}
      </div>
    </div>
  );
};
